import { FC, useContext } from "react";
import { ColSize, Form, InputForm, RowSize } from "../../../shared/components";
import { Image } from "antd/lib";
import { LogoColorfull } from "../../../assets";
import {
  EyeFilled,
  EyeInvisibleFilled,
  LockOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { ActionButton } from "@hdi-seguros/web-components.action-button";
import { ValidateForm } from "../../../shared/utils";
import { AuthContext } from "../../../shared/contexts";
import { useNavigate } from "react-router-dom";
import './index.css'
import { Card } from "@hdi-seguros/web-components.card";
interface LoginForm {
    username: string;
    password: string;
}
 
interface LoginFormProps {
    onForgotPassword: () => void;
}

export const LoginForm: FC<LoginFormProps> = ({onForgotPassword}) => {
  const validateForm = new ValidateForm();
  const authContext = useContext(AuthContext);
  const navigate = useNavigate();

  const onFinish = async (form: LoginForm) => {
    try {
      const resp = await authContext.login(form.username, form.password);

      // El PrivateWrapper atrapa antes de llegar al home y fuerza la selección de un intermediario.
      if (resp) navigate("/home");
    } catch (error) {}
  };

  return (
    <Form
      formProps={{
        autoComplete: "off",
        name: "login",
        onFinish: onFinish,
        className: "form"
      }}
    >
      
        <RowSize className="login_form-container">
          <div>
              <ColSize size={100}>
                <div className="login_form_logo-container">
                  <Image
                    src={LogoColorfull}
                    width={250}
                    height={"auto"}
                    preview={false}
                  />
                </div>
                <div className="login_form-title-container">
                  <h2>Inicia Sesión</h2>
                </div>
                <InputForm
                  formProps={{
                    name: "username",
                    rules: validateForm.generateRules({
                      label: "usuario",
                      rules: ["required", "notContainSpaces"],
                    }),
                  }}
                  inputProps={{
                    autoComplete: "username",
                    placeholder: "Usuario",
                    prefix: <UserOutlined />,
                    style: { height: 45, width: 300 },
                    autoFocus: true,
                  }}
                />
              </ColSize>

              <ColSize size={100}>
                <InputForm
                  formProps={{
                    name: "password",
                    rules: validateForm.generateRules({
                      label: "contraseña",
                      rules: ["required", "notContainSpaces"],
                    }),
                  }}
                  isPassword
                  inputPasswordProps={{
                    autoComplete: "current-password",
                    placeholder: "Contraseña",
                    prefix: <LockOutlined />,
                    style: { height: 45, width: 300 },
                    iconRender: (visible) =>
                      visible ? <EyeFilled /> : <EyeInvisibleFilled />,
                  }}
                />
              </ColSize>
              <ColSize size={100}>
                <RowSize rowProps={{ justify: "end", gutter: [0, 0] }}>
                  <ActionButton
                    label="Iniciar sesión"
                    type="primary"
                    htmlType="submit"
                    loading={authContext.isLoadingLogin}
                    data-label="Iniciar sesión"
                    width={300}
                    height={40}
                    className="login-form_button"
                  />
                </RowSize>
              </ColSize>
              <ActionButton className="login-form_button-text" type="text" onClick={onForgotPassword} label="¿Olvidaste tu contraseña?" ></ActionButton>
          </div>
        </RowSize>
    </Form>
  );
};